export const pt = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Jogar",
  "menu.name": "Nome",
  "menu.ballColor": "Cor da bola",
  "menu.nameColor": "Cor do nome",
  "menu.moreInfo": "Mais informações",
  "menu.moreInfoTitle": "Mais informações",
  "menu.moreInfoSubtitle": "Páginas legais, detalhes sobre cookies e informações de contacto.",
  "menu.back": "Voltar",
  "menu.privacySettings": "Definições de privacidade",
  "menu.cookiePolicy": "Política de cookies",
  "menu.privacyPolicy": "Política de privacidade",
  "menu.termsOfService": "Termos de serviço",
  "menu.emailButton": "Enviar e-mail",
  "menu.websiteButton": "Ver o meu site",
  "menu.contactEmailLabel": "E-mail de contacto:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Ver o meu site:",
  "menu.nameRequired": "Introduz primeiro um nome.",
  "moreInfo.privacySettings.intro1": "Podes gerir as tuas escolhas de privacidade neste site através da mensagem de consentimento apresentada pelo nosso fornecedor de publicidade quando estiver disponível.",
  "moreInfo.privacySettings.intro2": "Também podes controlar cookies e armazenamento local nas definições do teu navegador a qualquer momento.",
  "moreInfo.privacySettings.adsHeading": "Controlos de publicidade",
  "moreInfo.privacySettings.adsParagraph": "Alguns anúncios podem ser fornecidos pela Google ou por outros parceiros. As escolhas de publicidade personalizada também podem ser geridas diretamente nas definições de anúncios da Google.",
  "moreInfo.privacySettings.adsBullet1": "Abre os controlos de anúncios da Google em myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Limpa cookies ou dados do site se quiseres repor as tuas escolhas de consentimento.",
  "moreInfo.privacySettings.adsBullet3": "Usa as definições de privacidade do navegador para bloquear ou limitar cookies.",
  "moreInfo.privacySettings.localHeading": "Definições locais",
  "moreInfo.privacySettings.localParagraph": "Este jogo guarda preferências locais básicas, como o nome do jogador, cores, preferência de som e idioma, para que o site as possa recordar no teu dispositivo.",
  "moreInfo.cookiePolicy.intro1": "Este site usa cookies e tecnologias semelhantes de armazenamento para executar o jogo, recordar as tuas definições e apoiar a publicidade.",
  "moreInfo.cookiePolicy.intro2": "Os cookies também podem ser usados para medição, prevenção de fraude e personalização de anúncios, dependendo das tuas escolhas de consentimento e dos serviços ativados no site.",
  "moreInfo.cookiePolicy.typesHeading": "Tipos de cookies e armazenamento que podemos usar",
  "moreInfo.cookiePolicy.typeBullet1": "Armazenamento essencial usado para manter o site a funcionar.",
  "moreInfo.cookiePolicy.typeBullet2": "Armazenamento de preferências usado para recordar o teu nome, cores, idioma e definição de som.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookies de publicidade ou medição usados por parceiros de anúncios como a Google quando os anúncios estão ativados.",
  "moreInfo.cookiePolicy.manageHeading": "Como gerir cookies",
  "moreInfo.cookiePolicy.manageParagraph": "Podes gerir cookies através da mensagem de consentimento no site quando estiver disponível, ou através das definições do navegador. Desativar alguns cookies pode afetar funcionalidades do site ou a entrega de anúncios.",
  "moreInfo.privacyPolicy.intro1": "Este site é um jogo de navegador operado por Michał Kierzkowski. Tentamos recolher o mínimo possível de informação pessoal.",
  "moreInfo.privacyPolicy.intro2": "Não é necessária uma conta para jogar. O jogo pode guardar preferências locais básicas no teu dispositivo e processar dados de jogo necessários para partidas online.",
  "moreInfo.privacyPolicy.infoHeading": "Informações que podemos processar",
  "moreInfo.privacyPolicy.infoBullet1": "O nome de jogador escolhido e as definições cosméticas.",
  "moreInfo.privacyPolicy.infoBullet2": "Dados básicos de sessão necessários para executar funcionalidades multijogador.",
  "moreInfo.privacyPolicy.infoBullet3": "Dados de dispositivo, navegador ou publicidade recolhidos por parceiros de análise ou publicidade se esses serviços estiverem ativados.",
  "moreInfo.privacyPolicy.useHeading": "Como usamos as informações",
  "moreInfo.privacyPolicy.useBullet1": "Para executar o jogo e as salas online.",
  "moreInfo.privacyPolicy.useBullet2": "Para recordar as tuas definições no teu dispositivo.",
  "moreInfo.privacyPolicy.useBullet3": "Para melhorar o desempenho, a segurança e a estabilidade.",
  "moreInfo.privacyPolicy.useBullet4": "Para apresentar anúncios quando a publicidade está ativada.",
  "moreInfo.privacyPolicy.contactHeading": "Contacto",
  "moreInfo.privacyPolicy.contactParagraph1": "Se tiveres perguntas relacionadas com privacidade, contacta: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Site: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Ao usar este site, concordas em usar o jogo de forma legal e justa.",
  "moreInfo.terms.intro2": "O jogo é fornecido tal como está e pode ser alterado, interrompido ou removido a qualquer momento.",
  "moreInfo.terms.rulesHeading": "Regras",
  "moreInfo.terms.ruleBullet1": "Não abuses de bugs, batotas, automação ou exploits.",
  "moreInfo.terms.ruleBullet2": "Não tentes prejudicar o serviço ou outros jogadores.",
  "moreInfo.terms.ruleBullet3": "Não uses nomes ou conteúdos ofensivos, ilegais ou enganadores.",
  "moreInfo.terms.limitationHeading": "Limitação",
  "moreInfo.terms.limitationParagraph": "Não somos responsáveis por perdas, interrupções ou danos resultantes da utilização do site, na máxima medida permitida por lei.",
  "moreInfo.terms.changesHeading": "Alterações",
  "moreInfo.terms.changesParagraph": "Estes termos podem ser atualizados no futuro. A continuação da utilização do site após atualizações significa que aceitas os termos atualizados.",
  "status.offline": "A iniciar partida offline...",
  "status.connecting": "A ligar ao servidor...",
  "queue.title": "À espera de uma sala",
  "queue.menu": "Voltar ao menu principal",
  "game.pressToMove": "Prime em qualquer lugar para mover",
  "game.touchToMove": "Toca em qualquer lugar para mover",
  "game.leaderboard": "Classificação",
  "game.hp": "PV",
  "game.level": "Nível",
  "game.xp": "XP",
  "game.respawning": "A reaparecer...",
  "gameEnd.title": "Fim do jogo",
  "gameEnd.winTitle": "Ganhaste",
  "gameEnd.subtitle": "A partida terminou. Reaparece para iniciar a próxima ronda ou volta ao menu.",
  "pause.title": "Menu do jogo",
  "pause.resume": "Continuar",
  "pause.menu": "Voltar ao menu principal",
  "upgrade.title": "Escolhe uma melhoria",
  "upgrade.generic.title": "Melhoria",
  "upgrade.generic.description": "Melhora a tua build.",
  "upgrade.newWeaponPrefix": "Nova arma:",
  "upgrade.stat.maxHp.title": "PV máximo",
  "upgrade.stat.maxHp.description": "Aumenta os PV máximos.",
  "upgrade.stat.speed.title": "Velocidade de movimento",
  "upgrade.stat.speed.description": "Aumenta a velocidade de movimento.",
  "upgrade.stat.generic.title": "Melhoria de atributo",
  "upgrade.stat.generic.description": "Melhora os teus atributos.",
  "upgrade.weapon.projectileShot.title": "Disparo de projétil",
  "upgrade.weapon.projectileShot.description": "Adiciona disparos de projéteis à tua build.",
  "upgrade.weapon.orbitingBalls.title": "Bolas orbitais",
  "upgrade.weapon.orbitingBalls.description": "Adiciona bolas orbitais à tua build.",
  "upgrade.weapon.damageZone.title": "Zona de dano",
  "upgrade.weapon.damageZone.description": "Adiciona uma zona de dano à volta da personagem.",
  "upgrade.weapon.generic.title": "Arma",
  "upgrade.weapon.generic.description": "Adiciona esta arma à tua build.",
  "upgrade.weaponUpgrade.frequency.title": "Frequência",
  "upgrade.weaponUpgrade.frequency.description": "Ataca com mais frequência.",
  "upgrade.weaponUpgrade.range.title": "Alcance",
  "upgrade.weaponUpgrade.range.description": "Aumenta o alcance da arma.",
  "upgrade.weaponUpgrade.projectileCount.title": "Número de projéteis",
  "upgrade.weaponUpgrade.projectileCount.description": "Cria mais projéteis.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Velocidade dos projéteis",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Torna os projéteis mais rápidos.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Velocidade orbital",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Faz as bolas orbitais rodarem mais depressa.",
  "upgrade.weaponUpgrade.damage.title": "Dano",
  "upgrade.weaponUpgrade.damage.description": "Causa mais dano.",
  "upgrade.weaponUpgrade.generic.title": "Melhoria de arma",
  "upgrade.weaponUpgrade.generic.description": "Melhora esta arma.",
  "defeat.title": "Derrota",
  "defeat.subtitle": "Reaparece ou volta ao menu",
  "defeat.respawn": "Reaparecer",
  "defeat.menu": "Menu principal",
  "error.generic": "Algo correu mal.",
} as const;
